import { combineReducers } from 'redux';
import itemGridPreferences from './itemGridPreferencesSlice';
import auth from './auth/authSlice';
import appSettings from './appSettingsSlice';
import dashboardDateRange from './dashboardDateRangeSlice';

const rootReducer = combineReducers({
  itemGridPreferences,
  auth,
  appSettings,
  dashboardDateRange,
});

export default rootReducer;
